import React from "react";
import {
  HeroSection,
  BreadCrumbs,
  Container,
  Typography,
  Image,
  LoadMore,
} from "../../components";
import useHotProperty from "../../hooks/useHotProperty";
// import profileImage from "../../assets/profileImage.png";
import {
  NewsWrap,
  NewsItem,
  NewsInfo,
  NewsInfoItem,
  NewsInfoIcon,
  NewsSubTitle,
  NewsContainer,
} from "./hotPropertyElements";
import { BsFillPersonCheckFill } from "react-icons/bs";
import { Link } from "react-router-dom";

export default () => {
  const [hotPropertyList, setHotPropertyList] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);

  const { isLoading, data, isSuccess } = useHotProperty(currentPage);

  React.useEffect(() => {
    if (data) {
      if (currentPage === 1) {
        setHotPropertyList(data.property);
      } else {
        setHotPropertyList([...hotPropertyList, ...data.property]);
      }
    }
  }, [data]);

  return (
    <>
      <HeroSection
        title="Big Hound Property Picks"
        description="Here is what's trending now."
      />
      <Container>
        <BreadCrumbs data={[{ title: "Big Hound Property Picks" }]} />
        {isLoading && hotPropertyList.length === 0 ? (
          <Typography h3>Loading...</Typography>
        ) : (
          <NewsWrap>
            {hotPropertyList.map(({ id, title, image, excerpt, author }) => (
              <NewsItem key={id}>
                <Link to={`/hotProperty/${id}`}>
                  <Image
                    src={image}
                    style={{
                      width: "100%",
                      height: 250,
                      objectFit: "cover",
                    }}
                  />

                  <NewsContainer>
                    <NewsInfo>
                      <NewsInfoItem>
                        <NewsInfoIcon>
                          <BsFillPersonCheckFill />
                        </NewsInfoIcon>
                        <Typography body2>{author}</Typography>
                      </NewsInfoItem>
                    </NewsInfo>
                    <Typography h3>{title}</Typography>
                    <NewsSubTitle>
                      {excerpt && <Typography body1>{excerpt}</Typography>}
                    </NewsSubTitle>
                  </NewsContainer>
                </Link>
              </NewsItem>
            ))}
          </NewsWrap>
        )}
        <LoadMore
          dataPerPage={data}
          allData={hotPropertyList}
          isLoading={isLoading}
          isSuccess={isSuccess}
          onClick={() => setCurrentPage(currentPage + 1)}
        />
      </Container>
    </>
  );
};
